var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirmaSubidaespol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 15,
    x2: 29.9,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a94d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005bcb"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,2.9c.9,0,1.7.4,2.2,1.1l1.1,1.5c.5.7,1.4,1.2,2.3,1.2h9.3c1.2,0,2.1.7,2.5,1.7H1.1v-2.7c0-1.5,1.2-2.7,2.7-2.7h7.5M28.9,12.3v12.1c0,1.5-1.2,2.7-2.7,2.7H3.8c-1.5,0-2.7-1.2-2.7-2.7v-12.1h27.9M11.3,1.9H3.8C1.7,1.9,0,3.6,0,5.7v3.7h29.9c0-2.1-1.7-3.7-3.7-3.7h-9.3c-.6,0-1.1-.3-1.5-.7l-1.1-1.5c-.7-.9-1.8-1.5-3-1.5h0ZM29.9,11.3H0v13.1c0,2.1,1.7,3.7,3.7,3.7h22.4c2.1,0,3.7-1.7,3.7-3.7v-13.1h0Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirmaSubidaespol);
export default __webpack_public_path__ + "static/media/FirmaSUBIDA(ESPOL).068cc796.svg";
export { ForwardRef as ReactComponent };